import { useParams, useNavigate } from "react-router-dom";
import { Tabs, FloatingSaveBar } from "#common";
import PrimaryInformation from "./primary_information";
import IntakeInformation from "./intake_information";
import MedicalRecords from "./medical_records";
import AnimalHeader from "./animal_header";
import AnimalPictures from "./animal_pictures";
import AddItem from "./add_item";
import { useApiState } from "#hooks";
import { IconArrowLeft } from "@tabler/icons-react";

function Animal() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state, onChange, isChanged, submit, reset } = useApiState(
    `/animal/${id}`,
    `/animal/${id}`,
  );
  const sectionTabs = [
    {
      name: "Primary Information",
      key: "PRIMARY",
      component: <PrimaryInformation animal={state} onChange={onChange} />,
    },
    {
      name: "Pictures",
      key: "PICTURES",
      component: <AnimalPictures animal={state} onChange={onChange} />,
    },
    {
      name: "Intake Information",
      key: "INTAKE",
      component: <IntakeInformation />,
    },
    {
      name: "Records",
      key: "RECORDS",
      component: <MedicalRecords animal={state} />,
    },
  ];
  return (
    <div className="pb-24 mx-2">
      <button
        onClick={() => navigate(-1)}
        className="my-4 p-2 hover:bg-gray-200 rounded-lg"
      >
        <IconArrowLeft />
      </button>
      <AnimalHeader animal={state ?? {}} />
      <Tabs tabs={sectionTabs} defaultValue={sectionTabs[0].key}></Tabs>
      <FloatingSaveBar isChanged={isChanged} reset={reset} submit={submit} />
    </div>
  );
}
export default Animal;
